var scope_0 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1a18f9279eab980c89ba8543f71bc07b.js').default;

var scope_1 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1d308a02342b4f8320a1259a73bdb4d1.js').default;

var scope_2 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2208531e678a7ac6aab1be41ae8d2578.js').default;

var scope_3 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3141cb390ed62aa8c3832596406752c5.js').default;

var scope_4 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4a65110e24a542d5ddfb2123b87eab53.js').default;

var scope_5 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/51733783db21c78a6e2808f867b2b3f5.js').default;

var scope_6 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/54e7682d2ae91ce009b3453eead34548.js').default;

var scope_7 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/57c961a1270e5fdd17766181ecd93d7f.js').default;

var scope_8 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5f01b16a9c3935176a453c56db23aa72.js').default;

var scope_9 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/629a10bcf90b8b5150e74b99b0ae5552.js').default;

var scope_10 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6a8fbd9aac0b60243127bd6ed9efaa43.js').default;

var scope_11 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/883f1b572b8ab2fdf4b2af3e6d3cb64a.js').default;

var scope_12 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9f83940ec7cba8db2d39266697f59c17.js').default;

var scope_13 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a004554edccf7906d8bb92f702629e18.js').default;

var scope_14 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a7ce1fadd4f1289fbe791121b330f005.js').default;

var scope_15 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a92cf7d836ba601f0bc10f7a06778b64.js').default;

var scope_16 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ab468db663a34910121107daf8158d27.js').default;

var scope_17 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b14d616d81b85a00c2198c6c44860764.js').default;

var scope_18 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b7632813d7e8e56bcca6ded98f7f9cd0.js').default;

var scope_19 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bcb98ca6425666ce768d38e09ff61c48.js').default;

var scope_20 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bd92c28c313100b73f5109f2f5fff516.js').default;

var scope_21 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bee251aefda8ebe0b8bb3ff228063978.js').default;

var scope_22 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cd17e6e09a8fcdfad569af9508f4a6ec.js').default;

var scope_23 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d0badf007ee8d3b4e72a1a830b972783.js').default;

var scope_24 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/df33066f93d85eee2cd1f714dfdb575e.js').default;

var scope_25 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var scope_26 = require('/opt/build/repo/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f046b7e2e619a447d4ed9c0bb5dd9038.js').default;

export default Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13, scope_14, scope_15, scope_16, scope_17, scope_18, scope_19, scope_20, scope_21, scope_22, scope_23, scope_24, scope_25, scope_26);